/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
'use memo';
import React, { useEffect, useState } from 'react';
import { trackFooterNavMenu } from '../utils/track';
import styles from './ContentBlock.module.scss';
import { SmartLink as Link } from '@/utils/smartLink';
import { useLabels } from '@/hooks/useLabels';
import { isServer } from '@/utils/isServer';

const trackFooterLink = (linkName: string) => {
  trackFooterNavMenu(linkName);
  if (!isServer) {
    window.scrollTo(0, 0);
  }
};

const labelMap = {
  newWindow: 'label_OpenaNewWindow',
};

export type ContentBlockWrapperProps = {
  label: string;
  CTALink: string;
  children: React.ReactNode;
  Icon: boolean;
  name: string;
  handleOpenModal?: () => void;
  index?: number;
};

export function ContentBlockWrapper({
  children,
  CTALink,
  label,
  Icon,
  name,
  handleOpenModal,
}: ContentBlockWrapperProps) {
  const [shouldFocusTop, setShouldFocusTop] = useState(false);

  const labels = useLabels(labelMap);

  useEffect(() => {
    if (shouldFocusTop) {
      const azLogoFixed = document.getElementById('azLogoLinkFixed');
      azLogoFixed?.focus();
      setShouldFocusTop(false);
    }
  }, [shouldFocusTop]);

  return (
    <>
      {CTALink === '' ? (
        <div
          data-testid="openStoreModalBtn"
          role="button"
          onClick={handleOpenModal ? () => handleOpenModal() : undefined}
          className={`${styles.footerTopIconLabelButton} ${styles.mobileRectangle}`}
          onKeyPress={(event) => {
            if (handleOpenModal && event.key === 'Enter') {
              handleOpenModal();
            }
          }}
          tabIndex={0}
        >
          {children}
        </div>
      ) : (
        <Link
          to={CTALink || '#'}
          onClick={() => {
            setShouldFocusTop(true);
            trackFooterLink(label);
          }}
          className={`${Icon ? styles.footerTopSocialIcon : styles.footerTopIconLabelButton} ${
            styles.mobileRectangle
          }`}
          data-testid={`footer_content_block_${name.split(' ')[0]}`}
          externalLinkLabel={labels.newWindow}
        >
          {children}
        </Link>
      )}
    </>
  );
}
